import React, { useCallback } from 'react';
import { VisuallyHiddenInput } from '@fourthwall/components';
import { useFormikContext } from '@fourthwall/utils/dist/formik';
import { routing } from '@utils/routing';
import { getOfferTypeUtil } from '../../../../../Product.utils';
import { CategorySelect } from './components/CategorySelect';
import { useProductCategory } from './hooks/useProductCategory';
export const ProductCategory = ({ disabled }) => {
    const { values, setFieldValue, errors } = useFormikContext();
    const offerType = getOfferTypeUtil(values.manufacturingService);
    const handleCategorySelect = useCallback((categoryId) => {
        setFieldValue('categoryId', categoryId);
    }, [setFieldValue]);
    const { initialCategory, selectedCategory, parentCategory, selectCategory, options, areOptionsLoading, search, reset, } = useProductCategory({
        offerType,
        initialCategoryId: values.categoryId,
        onCategorySelect: handleCategorySelect,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(VisuallyHiddenInput, { name: "categoryId" }),
        React.createElement(CategorySelect, { label: "Product category", suggestion: React.createElement(React.Fragment, null,
                "Required for calculating sales tax.",
                ' ',
                React.createElement("a", { href: routing.external.helpCenter.productCategory, target: "_blank", rel: "noreferrer" }, "Learn more")), initialCategory: initialCategory, selectedCategory: selectedCategory, parentCategory: parentCategory, options: options, areOptionsLoading: areOptionsLoading, error: errors.categoryId, search: search, onSelect: selectCategory, disabled: disabled, onReset: reset })));
};
